/**
 * @generated SignedSource<<9b7d7f2df45edc594ce6868bad1e6e26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ScormCompletionStatus = "completed" | "failed" | "incomplete" | "not_attempted" | "passed" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ContentUsageMarkAsCompleteButtonFragment$data = {
  readonly confirmationModalContent: {
    readonly " $fragmentSpreads": FragmentRefs<"CurriculumConfirmationModalConfirmationModalFragment">;
  } | null;
  readonly id: string;
  readonly requireScormCompletion: boolean;
  readonly viewerScormCompletion: {
    readonly status: ScormCompletionStatus;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"usePermissionsFragment" | "useTrackContentCompletionFragment">;
  readonly " $fragmentType": "ContentUsageMarkAsCompleteButtonFragment";
};
export type ContentUsageMarkAsCompleteButtonFragment$key = {
  readonly " $data"?: ContentUsageMarkAsCompleteButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentUsageMarkAsCompleteButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentUsageMarkAsCompleteButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTrackContentCompletionFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ScormCompletion",
      "kind": "LinkedField",
      "name": "viewerScormCompletion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requireScormCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "confirmationModalContent",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CurriculumConfirmationModalConfirmationModalFragment"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePermissionsFragment"
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "164036f1c3d5dc630f7ac3a11f42f7df";

export default node;
